import { render, staticRenderFns } from "./AuthorModalContent.vue?vue&type=template&id=4d3fbc45&"
import script from "./AuthorModalContent.vue?vue&type=script&lang=ts&"
export * from "./AuthorModalContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports